export const {
	transpileModule: TypeScript_transpileModule,
	createSourceFile,
	forEachChild,
	JsxEmit: { None, Preserve, React, ReactNative, ReactJSX, ReactJSXDev },
	ScriptTarget: { ESNext },
	ScriptKind: { TS, TSX },
	SyntaxKind,
}                              = require('typescript');

export const {
	TypeAliasDeclaration,
	TypeAssertionExpression,
	AsExpression,
	HeritageClause,
	FunctionExpression,
	FunctionDeclaration,
	ClassDeclaration,
	ClassExpression,
	ArrowFunction,
	MethodDeclaration,
	GetAccessor,
	SetAccessor,
	TypeParameter,
	VariableDeclaration,
	PropertyDeclaration,
	Parameter,
	QuestionToken,
	CallExpression,
	NewExpression,
	InterfaceDeclaration,
	EnumDeclaration,
	DeclareKeyword,
	Block,
	//EndOfFileToken,
	NonNullExpression,
	ModuleDeclaration,
	ReadonlyKeyword,
	PrivateKeyword,
	ProtectedKeyword,
	PublicKeyword,
	ExportAssignment,
	ImportEqualsDeclaration,
	ReturnStatement,
	ThrowStatement,
	YieldExpression,
	IndexSignature,
	AbstractKeyword,
	//NamespaceExportDeclaration,
	ExportDeclaration,
	ImportDeclaration,
	ImportClause,
	Constructor,
	ExclamationToken,
	ExpressionWithTypeArguments,
	TaggedTemplateExpression,
	OverrideKeyword,
	EqualsGreaterThanToken,
	JsxElement,
	JsxSelfClosingElement,
	JsxOpeningElement,
	JsxClosingElement,
	JsxFragment,
	JsxOpeningFragment,
	JsxClosingFragment,
	JsxAttribute,
	JsxAttributes,
	JsxSpreadAttribute,
	JsxExpression,
	JsxText,
	//JsxTextAllWhiteSpaces,
	BinaryExpression,
	CommaToken,
	Identifier,
	ObjectLiteralExpression,
	ShorthandPropertyAssignment,
	SpreadAssignment,
	PropertyAssignment,
	ComputedPropertyName,
	StringLiteral,
	ImplementsKeyword,
	ExtendsKeyword,
	StaticKeyword,
	AsyncKeyword,
	ExportKeyword,
	ConstKeyword,///
	DefaultKeyword,///
	NamedImports,
	NamedExports,
} = SyntaxKind;

                                                     
                                                    
                                                  

                                       
                                                             
                                         
                                                     
                                                     
                                                       
                                                       
                                             
                                           
                                                       
                                             
                                       
                                                   
                                             
                                                           
                                       
                                                     
                                           
                                             
                                                                 
                                                               
                                                               
                                                               
                                                     
                                                         
                                                     
                                                   
                                           
                                                                         
                                                 
                                               
                                                 
                                                     
                                                       
                                                   
                                                 
                                             
                                                         
                                                         
                                                     
                                                 
                                                                 
                                           
                                           

                                      